export default __webpack_public_path__ + "static/media/Dioceses_w.0d061449.svg";